<template>
        <ul class="tags">
            <li class="tags__item" :class="{_active: tagsItem.tagActive}" v-for="tagsItem of tagsItems">
                {{ tagsItem.name }}
            </li>
        </ul>
</template>

<script>
export default {
    name: 'tagsItem',
    data() {
        return {
            tagsItems: [
                {
                    name: 'Категория 1',
                    tagActive: true
                },
                {
                    name: 'Категория 2',
                },
                {
                    name: 'Категория 3',
                },
            ]
        }
    },
}
</script>


